import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)

// serviceWorker switched off for now. Needs to be tested.
serviceWorker.unregister()
